import { render } from "./SpaDayBooking.vue?vue&type=template&id=5e0474ee"
import script from "./SpaDayBooking.vue?vue&type=script&lang=js"
export * from "./SpaDayBooking.vue?vue&type=script&lang=js"

import "@/css/booking/booking.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__